import { createVNode, render } from 'vue'

import MessageMain from '@/components/common/MessageToast.vue'

const div = document.createElement('div')

document.body.appendChild(div)

let timer:any = null

/**默认显示时间 */
const defaultSecond = 3000;
 
export default ({ type, text, bind, second = defaultSecond}:any) => {
    const vnode = createVNode(MessageMain, { type, text, bind, })

    render(vnode, div)

    clearTimeout(timer);
    timer = setTimeout(() => {
        render(null, div)
    // }, 60*60*1000)
    }, second)
}

